(() => {
  if (window.__spReviewVotes) return;
  window.__spReviewVotes = true;
  const param = new URLSearchParams(location.search).get('sp_votes');
  const OFF = param === 'off';
  const FORCE = /^[A-H]$/i.test(param || '') ? param.toUpperCase() : null;
  const DEFAULT = 'D';
  const VARIANTS = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H'];
  const KEY = 'sp-rv-vote:';
  const LABEL = { A: 'Helpful?', D: 'Was this helpful?' };

  const store = {
    get(id) { try { return localStorage.getItem(KEY + id); } catch (e) { return null; } },
    set(id, v) { try { v ? localStorage.setItem(KEY + id, v) : localStorage.removeItem(KEY + id); } catch (e) {} },
  };

  if (window.__spQA == null) window.__spQA = (function () { var q = /[?&]sp_qa=([01])(?:&|$)/.exec(location.search), s = false; try { if (q) localStorage.setItem('sp_qa', q[1]); s = localStorage.getItem('sp_qa') === '1'; } catch (e) {} var r = window.Shopify && window.Shopify.theme && window.Shopify.theme.role; return s || /^(localhost|127\.0\.0\.1)$/.test(location.hostname) || /SimplePaperQA/.test(navigator.userAgent) || (!!r && r !== 'main'); })();
  const pending = [];
  let consent = null;
  const allowed = () => { try { const api = window.Shopify && window.Shopify.customerPrivacy; if (!api || typeof api.analyticsProcessingAllowed !== 'function') return null; return !!api.analyticsProcessingAllowed(); } catch (e) { return null; } };
  const deliver = (props, name = 'sp_review_vote') => {
    if (window.__spQA) { console.debug('[sp-review-votes] qa visit, not sent', name, props); return; }
    if (name === 'sp_review_vote') postVote(props);
    try { if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') window.Shopify.analytics.publish(name, props); } catch (e) {}
    try { if (window.posthog && typeof window.posthog.capture === 'function') window.posthog.capture(name, props); } catch (e) {}
    try { if (typeof window.gtag === 'function') window.gtag('event', name, props); } catch (e) {}
  };
  const settle = () => { const a = allowed(); if (a === null) return; consent = a; if (a) pending.forEach(p => deliver(p.props, p.name)); pending.length = 0; };
  settle();
  document.addEventListener('visitorConsentCollected', settle);
  setTimeout(settle, 1200);
  setTimeout(() => { if (consent === null) { consent = false; pending.length = 0; } }, 8000);
  function send(name, props) {
    console.debug('[sp-review-votes]', name, props);
    if (consent === true) deliver(props, name);
    else if (consent === null && pending.length < 40) pending.push({ name, props });
  }
  window.spRvSend = send;
  if (OFF) return;
  const LOCAL = /^(localhost|127\.0\.0\.1)$/.test(location.hostname);
  const VOTE_API = (LOCAL ? 'http://localhost:8686' : 'https://simplepaper.app') + '/api/review-votes';
  function anonId() {
    let a = null;
    try { a = localStorage.getItem('sp-rv-anon'); } catch (e) {}
    if (!a) {
      a = (crypto.randomUUID && crypto.randomUUID()) || ('a' + Date.now().toString(36) + Math.random().toString(36).slice(2, 12));
      try { localStorage.setItem('sp-rv-anon', a); } catch (e) {}
    }
    return a;
  }
  function postVote(p) {
    try {
      fetch(VOTE_API, { method: 'POST', credentials: 'omit', keepalive: true, headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ product_id: p.product_id, review_hash: p.review_hash, anon_id: anonId(), vote: p.vote, surface: p.surface }) })
        .catch(() => {});
    } catch (e) {}
  }
  let countsP = null;
  function helpfulCounts() {
    const pid = String(productId());
    if (!/^\d{1,20}$/.test(pid)) return Promise.resolve({});
    if (!countsP) countsP = fetch(VOTE_API + '?product_id=' + pid, { credentials: 'omit' })
      .then(r => (r.ok ? r.json() : {})).then(j => (j && j.helpful) || {}).catch(() => ({}));
    return countsP;
  }
  window.spRvHelpfulCounts = helpfulCounts;
  function sendReviewVote(reviewId, vote, variant, surface) {
    const props = { product_id: String(productId()).slice(0, 40), review_hash: reviewId, vote: vote || 'cleared', variant, surface };
    if (LOCAL) postVote(props);
    send('sp_review_vote', props);
  }
  const shownOnce = {};
  function sendShown(el) {
    const surface = el.closest('.kl_reviews__lightbox_background') ? 'viewer' : 'list';
    const k = surface + ':' + el.dataset.spRvId;
    if (shownOnce[k]) return;
    shownOnce[k] = 1;
    send('sp_review_helpful_shown', { product_id: String(productId()).slice(0, 40), review_hash: el.dataset.spRvId, variant: el.dataset.variant, surface });
  }

  function hash(s) {
    let h = 0x811c9dc5;
    for (let i = 0; i < s.length; i++) { h ^= s.charCodeAt(i); h = Math.imul(h, 0x01000193); }
    return (h >>> 0).toString(36);
  }

  const productId = () => (document.getElementById('sp-rv26-ctx') || {}).dataset?.pid || location.pathname;
  const text = (el, sel) => ((el.querySelector(sel) || {}).textContent || '').trim().replace(/\s+/g, ' ');
  const name = (el, sel) => { const n = el.querySelector(sel); if (!n) return ''; const c = n.cloneNode(true); c.querySelectorAll('.kl_reviews__review__verified, .sp-rv-vote').forEach(x => x.remove()); return c.textContent.trim().replace(/\s+/g, ' '); };
  const reviewId = item => 'r' + hash([productId(), name(item, '.kl_reviews__review__author'), text(item, '.kl_reviews__review__content').slice(0, 400)].join('|'));
  const plain = s => { s = String(s || ''); if (/[<&]/.test(s)) s = new DOMParser().parseFromString(s, 'text/html').body.textContent || ''; return s.trim().replace(/\s+/g, ' '); };
  window.spRvIdFor = (author, content) => 'r' + hash([productId(), plain(author), plain(content).slice(0, 400)].join('|'));

  const HAND = 'M6.5 9.25 9.4 3.6c.37-.72 1.37-.8 1.85-.15.27.37.33.86.22 1.3L10.8 7.75h4.45c1.1 0 1.9 1.04 1.62 2.1l-1.4 5.5c-.2.8-.92 1.4-1.75 1.4H6.5Z';
  const CUFF = 'M3 9.25h3.5v7.5H3z';
  const icon = dir => `<svg class="sp-rv-vote__icon" viewBox="0 0 20 20" width="20" height="20" aria-hidden="true" focusable="false"${dir === 'down' ? ' data-dir="down"' : ''}>
    <path class="sp-rv-vote__fill" d="${CUFF}"/><path class="sp-rv-vote__line sp-rv-vote__hand" d="${HAND}"/><path class="sp-rv-vote__line sp-rv-vote__cuff" d="${CUFF}"/></svg>`;

  function build(variant, id) {
    const el = document.createElement('sp-review-vote');
    el.className = `sp-rv-vote sp-rv-vote--${variant}`;
    el.dataset.variant = variant;
    el.dataset.spRvId = id;
    el.setAttribute('role', 'group');
    el.setAttribute('aria-label', 'Was this review helpful?');
    el.innerHTML = `${FORCE ? `<span class="sp-rv-vote__tag" aria-hidden="true">Variant ${variant}</span>` : ''}
      <span class="sp-rv-vote__ui">
        ${LABEL[variant] ? `<span class="sp-rv-vote__label" aria-hidden="true">${LABEL[variant]}</span>` : ''}
        <span class="sp-rv-vote__btns">
          <button type="button" class="sp-rv-vote__btn" data-vote="up" aria-label="Helpful" aria-pressed="false">${icon('up')}<span class="sp-rv-vote__n" aria-hidden="true"></span></button>
          <button type="button" class="sp-rv-vote__btn" data-vote="down" aria-label="Not helpful" aria-pressed="false">${icon('down')}</button>
        </span>
        <span class="sp-rv-vote__thanks" aria-live="polite"></span>
      </span>`;
    el.addEventListener('click', e => {
      const b = e.target.closest('.sp-rv-vote__btn'); if (!b) return;
      e.preventDefault(); e.stopPropagation();
      vote(el, b.dataset.vote);
    });
    if (!(id in atLoad)) atLoad[id] = store.get(id);
    paint(el, store.get(id));
    paintCount(el);
    return el;
  }
  const atLoad = {};
  let counts = null;
  const SHOW_COUNT = false;
  function paintCount(el) {
    const id = el.dataset.spRvId, up = el.querySelector('[data-vote="up"]'), out = up && up.querySelector('.sp-rv-vote__n');
    if (!SHOW_COUNT || !out || !counts) return;
    const n = Math.max(0, (counts[id] || 0) + (store.get(id) === 'up' ? 1 : 0) - (atLoad[id] === 'up' ? 1 : 0));
    out.textContent = n > 0 ? String(n) : '';
    if (n > 0) el.dataset.count = String(Math.min(String(n).length, 3)); else delete el.dataset.count;
    up.setAttribute('aria-label', n > 0 ? `Helpful, ${n} ${n === 1 ? 'person' : 'people'} found this helpful` : 'Helpful');
  }

  function paint(el, v) {
    el.querySelectorAll('.sp-rv-vote__btn').forEach(b => b.setAttribute('aria-pressed', String(b.dataset.vote === v)));
    if (v) el.dataset.voted = v; else delete el.dataset.voted;
  }
  const touch = () => matchMedia('(hover: none), (pointer: coarse)').matches;
  function thanksFor(v) {
    if (touch()) return v === 'up' ? 'Glad it helped' : 'Thanks for telling us';
    return v === 'up' ? 'Thanks, glad this review helped' : "Thanks, we'll take note";
  }

  function vote(el, v) {
    const id = el.dataset.spRvId;
    const next = store.get(id) === v ? null : v;
    store.set(id, next);
    paint(el, next);
    paintCount(el);
    clearTimeout(el._j);
    if (next) { el.dataset.just = next; el._j = setTimeout(() => { delete el.dataset.just; }, 700); } else delete el.dataset.just;
    document.querySelectorAll('.sp-rv-vote').forEach(o => { if (o !== el && o.dataset.spRvId === id) { paint(o, next); paintCount(o); } });
    const thanks = el.querySelector('.sp-rv-vote__thanks');
    clearTimeout(el._t);
    if (next) {
      thanks.textContent = thanksFor(next);
      el.dataset.thanks = '';
      el._t = setTimeout(() => { delete el.dataset.thanks; }, 2400);
    } else {
      thanks.textContent = '';
      delete el.dataset.thanks;
    }
    document.dispatchEvent(new CustomEvent('sp:review-vote', { detail: { reviewId: id, vote: next } }));
    sendReviewVote(id, next, el.dataset.variant, el.closest('.kl_reviews__lightbox_background') ? 'viewer' : 'list');
  }

  function place(item, el, variant) {
    if (variant === 'E') {
      const t = item.querySelector('.kl_reviews__time_badge');
      if (t) { t.classList.add('sp-rv-vote-host'); t.appendChild(el); return; }
    }
    if (variant === 'G') {
      const badge = item.querySelector('.kl_reviews__review__verified');
      const author = item.querySelector('.kl_reviews__review__author');
      if (badge) { badge.after(el); return; }
      if (author) { author.appendChild(el); return; }
    }
    if (variant === 'D') {
      const anchor = item.querySelector('.kl_reviews__review__variant') || item.querySelector('.kl_reviews__review__content');
      if (anchor) { anchor.after(el); return; }
    }
    item.appendChild(el);
  }

  function scan() {
    const items = [...document.querySelectorAll('[id*="klaviyo_reviews"] .kl_reviews__review_item')]
      .filter(i => !i.closest('.kl_reviews__lightbox_background'));
    items.forEach((item, idx) => {
      const id = reviewId(item);
      const have = item.querySelectorAll('.sp-rv-vote');
      if (have.length === 1 && have[0].dataset.spRvId === id) return;
      have.forEach(n => n.remove());
      const variant = FORCE || DEFAULT;
      place(item, build(variant, id), variant);
      if (seen) seen.observe(item);
    });
  }
  const panelId = panel => 'r' + hash([productId(), name(panel, '.kl_reviews__lightbox__right__meta strong'), text(panel, ':scope > p').slice(0, 400)].join('|'));
  function scanViewer() {
    document.querySelectorAll('.kl_reviews__lightbox_background .kl_reviews__lightbox__right').forEach(panel => {
      if (!panel.querySelector(':scope > p')) return;
      const id = panelId(panel);
      const have = panel.querySelectorAll('.sp-rv-vote');
      if (have.length === 1 && have[0].dataset.spRvId === id) return;
      have.forEach(n => n.remove());
      const twin = [...document.querySelectorAll('.sp-rv-vote')].find(o => o.dataset.spRvId === id && !panel.contains(o));
      const variant = FORCE || (twin && twin.dataset.variant) || DEFAULT;
      const el = build(variant, id);
      el.classList.add('sp-rv-vote--in-viewer');
      const badge = variant === 'G' && panel.querySelector('.kl_reviews__review__verified');
      if (badge) { badge.after(el); return; }
      const after = panel.querySelector(':scope > .sp-kr-more') || panel.querySelector(':scope > p');
      after.after(el);
    });
  }
  document.addEventListener('click', e => {
    const t = e.target;
    if (!t || !t.closest || t.closest('.kl_reviews__lightbox_background')) return;
    const item = t.closest('[id*="klaviyo_reviews"] .kl_reviews__review_item');
    if (!item || t.closest('a, .kl_reviews__review__image_container, .kl_reviews__review__images, .sp-rv-vote')) return;
    const el = item.querySelector('.sp-rv-vote');
    if (!el || el.hasAttribute('data-open')) return;
    el.setAttribute('data-open', '');
    sendShown(el);
  }, true);
  document.addEventListener('mouseover', e => {
    const item = e.target && e.target.closest && e.target.closest('[id*="klaviyo_reviews"] .kl_reviews__review_item');
    if (!item || item.closest('.kl_reviews__lightbox_background') || touch()) return;
    const el = item.querySelector('.sp-rv-vote'); if (el) sendShown(el);
  }, { passive: true });
  const seen = 'IntersectionObserver' in window ? new IntersectionObserver(es => es.forEach(en => {
    if (!en.isIntersecting || !touch()) return;
    const el = en.target.querySelector('.sp-rv-vote'); if (el) sendShown(el);
    seen.unobserve(en.target);
  }), { threshold: 0.5 }) : null;
  function viewerShown() {
    document.querySelectorAll('.kl_reviews__lightbox_background .sp-rv-vote').forEach(el => { if (el.getClientRects().length) sendShown(el); });
  }
  const SORT = 'kl_reviews__sort_by_reviews', HELPFUL = 'sp-helpful';
  function sortOption() {
    const s = document.getElementById(SORT); if (!s) return;
    if (!s.querySelector(`option[value="${HELPFUL}"]`)) { const o = document.createElement('option'); o.value = HELPFUL; o.text = 'Most helpful'; s.appendChild(o); }
    if (window.__spKrHelpful && s.value !== HELPFUL) s.value = HELPFUL;
  }
  const viaOther = (s, end) => {
    const fire = v => { s.value = v; s.dispatchEvent(new Event('change', { bubbles: true })); };
    s._spBusy = true;
    fire('0');
    setTimeout(() => { fire('3'); setTimeout(() => { s._spBusy = false; if (end) s.value = end; }, 60); }, 60);
  };
  document.addEventListener('change', e => {
    const s = e.target; if (!s || s.id !== SORT || s._spBusy) return;
    if (s.value !== HELPFUL) {
      const was = window.__spKrHelpful; window.__spKrHelpful = false;
      if (was && s.value === '3') { e.stopImmediatePropagation(); viaOther(s); }
      return;
    }
    e.stopImmediatePropagation();
    window.__spKrHelpful = true;
    viaOther(s, HELPFUL);
    send('sp_review_sort', { product_id: String(productId()).slice(0, 40), sort: 'helpful' });
  }, true);

  let queued = false;
  const queue = () => { if (queued) return; queued = true; requestAnimationFrame(() => { queued = false; scan(); scanViewer(); viewerShown(); sortOption(); }); };
  const start = () => {
    scan();
    sortOption();
    helpfulCounts().then(c => { counts = c; document.querySelectorAll('.sp-rv-vote').forEach(paintCount); });
    new MutationObserver(muts => {
      if (muts.every(m => [...m.addedNodes, ...m.removedNodes].every(n => n.nodeType === 1 && (n.classList?.contains('sp-rv-vote') || n.closest?.('.sp-rv-vote'))))) return;
      queue();
    }).observe(document.body, { childList: true, subtree: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
